export default __webpack_public_path__ + "static/media/Halifax.82509ec5.svg";